import { render, staticRenderFns } from "./SuperAdmin.vue?vue&type=template&id=053f712b&scoped=true&"
import script from "./SuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdmin.vue?vue&type=style&index=0&id=053f712b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f712b",
  null
  
)

export default component.exports